import React from "react";
import AppBar from "../../Components/header";
import AppProvider from "../../Components/bootstrap";
import { Loading, useAuthenticated } from "react-admin";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/styles";

import { useParams } from "react-router";

import AppointmentWizard from "./AppointmentWizard";
import { Error } from "../MyProfile/Error";

import { useMentorProfileData, useSelectedMentor } from "./hooks";

const useStyles = makeStyles({
  root: {
    background: "linear-gradient(45deg, #EF8354 30%, #EF8354 90%)",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 38,
    width: 174,
  },
  paper: {
    marginTop: "15vh",
    margin: "auto",
    maxWidth: "90vw",
    marginBottom: "1vh",
  },

  avatar: {
    width: "6rem",
    height: "6rem",
    margin: 0,
  },
  gridBody: {
    padding: "1.5rem",
  },
});

export const NewAppointment = (props) => {
  useAuthenticated();
  const { mentorId } = useParams();
  const u = useMentorProfileData(mentorId);
  const { selectedMentor } = useSelectedMentor();
  if (u.loaded)
    selectedMentor({ name: u.data.name, id: mentorId, email: u.data.email_ });
  const classes = useStyles();

  if (u.error) {
    return <Error />;
  }
 
  return (
    <div>
      <AppBar />
      <AppProvider>
        <Paper elevation={2} className={classes.paper}>
          {!u.loaded ? (
            <Loading />
          ) : (
            <Grid
              container
              direction="column"
              spacing={2}
              className={classes.gridBody}
            >
              <Grid item>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="flex-start"
                  spacing={2}
                >
                  <Grid item>
                    <Avatar
                      className={classes.avatar}
                      src={u.data.profileImage ? u.data.profileImage._url : ""}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">{u.data.name}</Typography>
                    <Typography variant="body1">
                      Industry: {u.data.industry}
                    </Typography>
                    <Typography variant="body2">
                      {u.data.hoursConsulted}+ hours of Consultation
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item>
                {props.location.state !== undefined ? (
                  <Typography variant="body1">
                    Topic:{" "}
                    {props.location.state !== undefined &&
                    props.location.state.topic
                      ? props.location.state.topic
                      : ""}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid> */}

              <Grid item>
                <AppointmentWizard
                  aid={u.loaded ? u.data.availability.id : ""}
                  mentorDetails={u.loaded ? u.data : ""}
                  uid={localStorage.getItem("user")}
                  offer={
                    props.location.state
                      ? props.location.state.offer
                      : undefined
                  }
                />
              </Grid>
            </Grid>
          )}
        </Paper>
      </AppProvider>
    </div>
  );
};
